/* @flow */
import { ActionTypes } from '../constants/PaymentAccountConstants';
import { dispatcher } from 'lib/Dispatcher';
import PaymentAccount from 'entities/PaymentAccount';

const PaymentAccountActions = {
  load() {
    return PaymentAccount.load().then(paymentAccount => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_PAYMENT_ACCOUNT,
        paymentAccount,
      });

      return paymentAccount;
    });
  },

  requestVerificationHelp() {
    return PaymentAccount.requestVerificationHelp(...arguments);
  },

  patchPII() {
    return PaymentAccount.patchPII(...arguments).then(paymentAccount => {
      dispatcher.dispatch({
        type: ActionTypes.PATCH_PAYMENT_ACCOUNT,
        paymentAccount,
      });
    });
  },

  patch() {
    return PaymentAccount.patch(...arguments).then(paymentAccount => {
      dispatcher.dispatch({
        type: ActionTypes.PATCH_PAYMENT_ACCOUNT,
        paymentAccount,
      });

      return paymentAccount;
    });
  },
};

export default PaymentAccountActions;



// WEBPACK FOOTER //
// ./src/payments/actions/PaymentAccountActions.js